/** Translation keys by refusal reason (element.reason), server code, or HTTP status written as a string ("429"). */
export type Refusals = Record<string, string>;

export const refusalReason = (error: any): string | undefined => {
  const reason = error?.response?.data?.element?.reason;
  return typeof reason === "string" ? reason : undefined;
};

/** The fields that UMD's validation refused (400 RSUSKO007, `element` maps each field to its message). */
export const refusedFields = (error: any): string[] => {
  const element = error?.response?.data?.element;
  return error?.response?.data?.code === "RSUSKO007" &&
    element &&
    typeof element === "object" &&
    !Array.isArray(element)
    ? Object.keys(element)
    : [];
};

/** The translation key of what a visitor is told about a refused request: never the server's own text. */
export const refusalMessageKey = (
  error: any,
  refusals: Refusals,
  fallback: string
): string => {
  const reason = refusalReason(error);
  const code = error?.response?.data?.code;
  return (
    (reason && refusals[reason]) ||
    (typeof code === "string" && refusals[code]) ||
    refusals[String(error?.response?.status)] ||
    fallback
  );
};
